'use client'
import { Player } from "@lottiefiles/react-lottie-player";
/**
 * @typedef {import("@prismicio/client").Content.EcoRenovationSlice} EcoRenovationSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<EcoRenovationSlice>} EcoRenovationProps
 * @param {EcoRenovationProps}
 */

import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";
import { useEffect, useRef, useState } from "react";


const EcoRenovationItem = ({ argument, index, len, selected }) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggle(elem, isLast) {
    setIsOpen(!isOpen);
    if (isLast) {
      const eco_renov_container = document.querySelector('.eco-renov-container');
      eco_renov_container.classList.toggle('border-b-2');
      eco_renov_container.classList.toggle('border-b-0');
    }
  }
  return <div className={`${isOpen ? 'slide pb-[40px]' : ''} ${isOpen && index == len - 1 ? 'border-0 rounded-b-30px' : ''} eco-renov-element eco-renov-element-${index} m-auto px-4  md:p-10 lg:py-[60px] lg:px-[70px] md:border-0 md:rounded-30px md:h-[640px] lg:h-[600px] overflow-hidden ${index % 3 == 0 ? `bg-dark-green` : index % 2 ? `bg-dark-pink` : 'bg-dark-beige'} ${index === selected ? 'md:flex' : 'md:hidden'} ${index == len - 1 ? 'border-0' : 'border-b-2 md:border-0 border-dark-grey'}`}>
    <div
      className={`flex items-center justify-between py-3.5 md:hidden toggle-btn eco`} onClick={(e) => toggle(e, index == len - 1)}>
      <h3 className="text-center tab">{argument.tab_label}</h3>
      <div className=" w-fit ml-2.5 md:hidden ">
        <div className={`spin_arrow h-2 w-4 ${isOpen ? 'toggle-active' : ''}`}>
          <img src="/svg/arrow-faq.svg" loading="lazy" className="w-4 h-[9px]" alt="flèche"/>
        </div>
      </div>
    </div>
    <div className="flex justify-center mb-30px  mt-4 md:block md:mb-0 md:w-1/3 md:mt-0 md:block">
      <PrismicImage field={argument.picto} className="h-[80px] w-[80px] md:mb-4 object-contain" loading="lazy"/>
      <div className="ml-6 md:ml-0 eco-title">
        <PrismicRichText field={argument.title} />
      </div>
    </div>
    <div className="md:w-2/3 md:ml-[70px] md:block">
      <div className="md:mb-12 border-eco">
        <PrismicRichText field={argument.text} />
      </div>
      <div className="text-dark-grey">
        <div className="button button-rounded button-text overflow-hidden background-slide-white">
          <PrismicLink field={argument.cta_page}>{argument.cta_label}</PrismicLink>
        </div>
      </div>
    </div>
  </div>
}

const EcoRenovation = ({ slice, index, context }) => {

  const player = useRef();

  useEffect(() => {
    const $ecoSection = document.getElementById('eco-section');
    if ($ecoSection != null) observeEco($ecoSection)
  })

  function observeEco(elem) {
    const obs = {
      rootMargin: '', threshold: 0.1
    }
    function cb(entries) {
      entries.forEach(entry => {
        player.current.play()
      });
    };
    const observer = new IntersectionObserver(cb, obs)
    observer.observe(elem);
  }

  const [selected, setSelected] = useState(0);
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id="eco-section"
      className={`bg-white relative pb-[40px] md:pb-20 lg:pb-24 text-dark-grey ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} overflow-hidden`}>
      <div className="relative z-[10]">
        <div
          className="max-w-[1000px] pt-[40px] px-4 m-auto mb-12 md:px-7 lg:px-10 lg:px-0 md:flex md:pt-20 lg:pt-[90px] md:mb-16">
          <div className="md:w-1/2 mr-10 mb-30px md:mb-0">
            <h2 className="subtitle mb-2.5">
              {slice.primary.seo_title}
            </h2>
            <div className="h2-like">
              <PrismicRichText field={slice.primary.title} />
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center md:justify-end">
            <Player
              id="home-eco"
              className="w-[360px] h-auto md:w-[447px]"
              autoplay
              loop
              mode="normal"
              src="/anim/anim-pictos-eco.json">
            </Player>
            <div></div>
          </div>
        </div>
        <div className="md:max-w-[1000px] md:flex m-auto md:mx-7 lg:m-auto">
          <div>
            <div className="w-full border-2 border-dark-grey rounded-30px mb-[40px] hidden md:flex">
              {
                slice.primary.arguments.map((argument, i, array) => {
                  return <div
                    key={i}
                    className={`border-0 border-dark-grey w-full flex items-center justify-center cursor-pointer eco-renov-title
                        ${i === selected && i === 0 ? 'bg-dark-green' : i === selected && i === 1 ? 'bg-dark-pink' : i === selected && i === 2 ? 'bg-dark-beige' : 'bg-transparent'} 
                        ${i == 0 ? 'rounded-l-30px' : i == array.length - 1 ? 'rounded-r-30px' : ''}
                        ${i == array.length - 1 ? '' : 'border-r-2 border-dark-grey'}" data-element="eco-renov-element-${i}`}
                    data-color={`${i % 3 == 0 ? 'bg-dark-green' : i % 2 ? 'bg-dark-pink' : 'bg-dark-beige'}`}>
                    <h3 className="px-30px py-3.5 tab text-center m-auto" onClick={() => setSelected(i)}>{argument.tab_label}</h3>
                  </div>
                })
              }
            </div>
            <div className="border-b-2 border-t-2 border-dark-grey md:border-0 eco-renov-container">
              {
                slice.primary.arguments.map((argument, i, arr) => <EcoRenovationItem argument={argument} index={i} key={i} len={arr.length} selected={selected} />)
              }
            </div>
          </div>
        </div>
      </div>
      <div className="absolute overflow-hidden w-screen  top-0">
        <div id="home-eco-renovation" className="w-screen relative">
          <Player
            ref={player}
            id="home-eco"
            autoplay={false}
            loop={false}
            keepLastFrame
            src={context.isMobileViewer || context.isTabletViewer ? "/anim/coulure-home-eco-renovation-mobile.json" : "/anim/coulure-home-eco-renovation.json"}>
          </Player>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section >);
};

export default EcoRenovation;
